import { Layout } from "react-grid-layout";
import {
  CategoryDef,
  GroupMode,
  RowsData,
} from "api/interfaces/chartInterface.interface";
import {
  CardData,
  CardInfo,
  StatsLayout,
} from "api/interfaces/dashboardInterface.interface";
import { dwMenuData, logoutAbleUrl } from "./MenuUtil";
import { RoutesProp } from "api/interfaces/menuInterface.interface";
import { LuUsers } from "react-icons/lu";
import { BiBuildings, BiCctv } from "react-icons/bi";
import { HiOutlineServer } from "react-icons/hi";

export const C = {
  blue: "#6a98b9",
  green: "#7eb295",
  yellow: "#eab376",
  red: "#c57670",
  purple: "#8680ae",
};
export const CARD_INFOS: CardInfo[] = [
  {
    i: "userCount",
    title: "Users",
    icon: LuUsers,
    rows: [],
    graphType: "card",
    isRole: ["viewUsersAndGroups"],
  },
  {
    i: "organizationCount",
    title: "Organizations",
    icon: BiBuildings,
    rows: [],
    graphType: "card",
    isRole: ["viewAccount"],
  },
  {
    i: "recorderCount",
    title: "Recorders",
    icon: HiOutlineServer,
    rows: [],
    graphType: "card",
    isRole: ["viewAccount"],
  },
  {
    i: "cameraCount",
    title: "Cameras",
    icon: BiCctv,
    rows: [],
    graphType: "card",
    groupMode: "grouped" as GroupMode,
    isRole: ["viewAccount"],
  },
  {
    i: "userLogin",
    title: "User Login",
    rows: [],
    items: [
      {
        key: "count",
        label: "Logins",
        color: "#ed7422",
      },
    ],
    lengedType: "range",
    graphType: "line",
    isRole: ["viewUsersAndGroups"],
  },
  {
    i: "cameras",
    title: "Cameras",
    rows: [],
    items: [
      { key: "dwc", label: "DWC", color: C.yellow },
      { key: "etc", label: "ETC", color: C.green },
    ],
    graphType: "line",
    groupMode: "grouped" as GroupMode,
    isRole: ["viewAccount"],
  },
  {
    i: "organization",
    title: "Organization",
    rows: [],
    items: [
      { key: "cp", label: "CP", color: C.purple },
      { key: "subCp", label: "Sub CP", color: C.yellow },
      { key: "eu", label: "EU", color: C.blue },
    ],
    graphType: "line",
    isRole: ["viewAccount"],
  },
  {
    i: "clientDevices",
    title: "Client Devices",
    rows: [],
    items: [
      { key: "linux", label: "Linux", color: C.yellow },
      { key: "windows", label: "Windows", color: C.green },
      { key: "mac", label: "Mac", color: C.blue },
      { key: "android", label: "Android", color: C.purple },
      { key: "ios", label: "iOS", color: C.red },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewUsersAndGroups"],
  },
  {
    i: "spectrumRecorders",
    title: "Spectrum",
    rows: [],
    items: [
      { key: "enterprise", label: "Enterprise", color: C.red },
      { key: "professional", label: "Professional", color: C.green },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewAccount"],
  },
  {
    i: "covaRecorders",
    title: "COVA",
    rows: [],
    items: [
      { key: "4CH", label: "4CH", color: C.purple },
      { key: "8CH", label: "8CH", color: C.red },
      { key: "16CH", label: "16CH", color: C.green },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewAccount"],
  },
  {
    i: "vmaxA1Recorders",
    title: "VMAX-A1",
    rows: [],
    items: [
      { key: "4CH", label: "4CH", color: C.purple },
      { key: "8CH", label: "8CH", color: C.red },
      { key: "16CH", label: "16CH", color: C.green },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewAccount"],
  },
  {
    i: "vmaxIPRecorders",
    title: "VMAX-IP",
    rows: [],
    items: [
      { key: "4CH", label: "4CH", color: C.purple },
      { key: "8CH", label: "8CH", color: C.red },
      { key: "16CH", label: "16CH", color: C.green },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewAccount"],
  },
  {
    i: "bestPageView",
    title: "Best View Top 5",
    rows: [],
    items: [
      { key: "", label: "", color: C.red },
      { key: "", label: "", color: C.green },
      { key: "", label: "", color: C.blue },
      { key: "", label: "", color: C.purple },
      { key: "", label: "", color: C.yellow },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewUsersAndGroups"],
  },
  {
    i: "Recorders",
    title: "Recorders",
    rows: [],
    items: [
      { key: "spectrum", label: "Spectrum", color: C.green },
      { key: "cova", label: "COVA", color: C.purple },
      { key: "vmaxIp", label: "VMAX-IP", color: C.yellow },
      { key: "vmaxA1", label: "VMAX-A1", color: C.blue },
    ],
    graphType: "line",
    groupMode: "grouped" as GroupMode,
    isRole: ["viewAccount"],
  },
  {
    i: "subscriptionStatus",
    title: "Organization Status",
    rows: [],
    items: [
      { key: "enabled", label: "Enabled", color: C.blue },
      { key: "suspended", label: "Suspended", color: C.yellow },
      { key: "disabled", label: "Disabled", color: C.red },
    ],
    graphType: "stackedBar",
    groupMode: "grouped" as GroupMode,
    isRole: ["viewAccount"],
  },
  {
    i: "subscriptionKeys",
    title: "Subscription Keys",
    rows: [],
    items: [
      { key: "generated", label: "Generated", color: C.purple },
      { key: "activated", label: "Activated", color: C.green },
    ],
    graphType: "stackedBar",
    groupMode: "grouped" as GroupMode,
    isRole: ["subscriptionKeys"],
  },
  {
    i: "Users",
    title: "Users",
    rows: [],
    items: [
      { key: "cp", label: "CP", color: C.purple },
      { key: "subCp", label: "Sub CP", color: C.yellow },
      { key: "eu", label: "EU", color: C.blue },
    ],
    graphType: "line",
    isRole: ["viewUsersAndGroups"],
  },
  {
    i: "activeAlert",
    title: "Active Alert",
    rows: [],
    items: [
      { key: "System", label: "System", color: C.red },
      { key: "Video", label: "Video", color: C.yellow },
      { key: "Disk", label: "Disk", color: C.purple },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["viewAccount"],
  },
  {
    i: "videoShare",
    title: "Video Share",
    rows: [],
    items: [
      {
        key: "count",
        label: "Video Share",
        color: C.blue,
      },
    ],
    lengedType: "range",
    graphType: "line",
    isRole: ["viewAccount"],
  },
  {
    i: "cloudStorage",
    title: "Cloud Storage",
    rows: [],
    items: [
      { key: "unusedStorage", label: "Unused", color: C.red },
      { key: "usedStorage", label: "Used", color: C.yellow },
    ],
    graphType: "stackedBar",
    isRole: ["viewAccount"],
  },
  {
    i: "channelLicense",
    title: "Channel License Distribution",
    rows: [],
    items: [
      { key: "free", label: "Free (Trial/Free Key)", color: C.green },
      { key: "subscription", label: "Subscription Key", color: C.blue },
      {
        key: "plan",
        label: "Usage Based",
        color: C.yellow,
      },
      { key: "noLicense", label: "Suspended / Disabled", color: C.red },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["subscriptionOrganization"],
  },
  {
    i: "euLicense",
    title: "EU License Distribution",
    rows: [],
    items: [
      { key: "free", label: "Free (Trial/Free Key)", color: C.green },
      { key: "subscription", label: "Subscription Key", color: C.blue },
      {
        key: "plan",
        label: "Usage Based",
        color: C.yellow,
      },
      { key: "noLicense", label: "Suspended / Disabled", color: C.red },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["subscriptionOrganization"],
  },
  {
    i: "covaLicense",
    title: "COVA License Status",
    rows: [],
    items: [
      { key: "free", label: "1Y Free License", color: C.green },
      {
        key: "subscription",
        label: "Subscription Key",
        color: C.blue,
      },
      {
        key: "plan",
        label: "Usage Based",
        color: C.yellow,
      },
      { key: "noLicense", label: "No License", color: C.red },
    ],
    graphType: "donut",
    lengedType: "list",
    isRole: ["subscriptionOrganization"],
  },
];
export const LAYOUT_COLS = 4;

export const cardDataToLayout = (
  layout: (CardData | StatsLayout)[]
): Layout[] => {
  return layout.map((item) => {
    const graphType =
      item.graphType ?? CARD_INFOS.find((p) => p.i === item.i)?.graphType;
    return {
      i: item.i,
      x: item.x,
      y: item.y,
      w: item.w,
      h: item.h,
      graphType: graphType,
    };
  });
};
const chartNaturalW = (id: string) =>
  CARD_INFOS.find((d) => d.i === id)?.graphType === "donut" ? 1 : 2;

const layoutItemH = (item: Layout) => item.h ?? 1;

const layoutItemW = (item: Layout, cols: number) =>
  item.w != null ? Math.min(item.w, cols) : chartNaturalW(item.i);

/** 같은 행(y)의 위젯은 행 내 최대 높이로 맞춤 (저장된 h 우선) */
const syncRowHeights = (layout: Layout[]): Layout[] => {
  if (layout.length === 0) return layout;

  const rowMaxH = new Map<number, number>();
  for (const item of layout) {
    const h = layoutItemH(item);
    rowMaxH.set(item.y, Math.max(rowMaxH.get(item.y) ?? 0, h));
  }

  return layout.map((item) => ({
    ...item,
    h: rowMaxH.get(item.y) ?? item.h,
  }));
};

const sortLayoutsByPosition = (layouts: StatsLayout[]): StatsLayout[] =>
  [...layouts].sort((a, b) => {
    const aX = typeof a.x === "number" ? a.x : 0;
    const bX = typeof b.x === "number" ? b.x : 0;
    if (aX !== bX) return aX - bX;
    if (a.w === 1 && b.x !== 3) return -1;
    if (a.w === 2 && b.x < 3) return -1;
    return 1;
  });

const overlapsColumn = (item: Layout, col: number): boolean =>
  col >= item.x && col < item.x + item.w;

const canPlaceAt = (
  layout: Layout[],
  excludeIds: Set<string>,
  x: number,
  y: number,
  w: number,
  cols: number
): boolean => {
  if (x + w > cols) return false;
  return !layout.some(
    (item) =>
      !excludeIds.has(item.i) &&
      item.y === y &&
      item.x < x + w &&
      item.x + item.w > x
  );
};

const findFirstSlotLTRB = (
  layout: Layout[],
  w: number,
  cols: number
): { x: number; y: number } | null => {
  const maxY =
    layout.reduce((m, i) => Math.max(m, i.y + layoutItemH(i)), 0) +
    layout.length +
    1;

  for (let y = 0; y <= maxY; y++) {
    for (let x = 0; x <= cols - w; x++) {
      if (canPlaceAt(layout, new Set(), x, y, w, cols)) {
        return { x, y };
      }
    }
  }
  return null;
};

type PinnedLayoutItem = { id: string; x: number; y: number };

/** 전체 L→R·T→B 재배치. pin 있으면 드래그 카드는 drop 위치 고정 */
const reflowItemsLTRB = (
  layout: Layout[],
  cols: number,
  pin?: PinnedLayoutItem,
  sortOrderRef?: Layout[]
): Layout[] => {
  if (!layout.length) return layout;

  const normalized = layout.map((item) => ({
    ...item,
    w: Math.min(item.w, cols),
    h: layoutItemH(item),
  }));

  const sortPos = new Map(
    (sortOrderRef ?? layout).map((item) => [
      item.i,
      { y: item.y ?? 0, x: item.x ?? 0 },
    ])
  );

  const placed: Layout[] = [];

  const placeAt = (item: Layout, x: number, y: number) => {
    placed.push({
      ...item,
      x,
      y,
      w: Math.min(item.w, cols),
      h: layoutItemH(item),
    });
  };

  if (pin) {
    const pinned = normalized.find((i) => i.i === pin.id);
    if (pinned) placeAt(pinned, pin.x, pin.y);
  }

  const unpinned = normalized
    .filter((i) => i.i !== pin?.id)
    .sort((a, b) => {
      const pa = sortPos.get(a.i) ?? { y: a.y, x: a.x };
      const pb = sortPos.get(b.i) ?? { y: b.y, x: b.x };
      return pa.y - pb.y || pa.x - pb.x || a.i.localeCompare(b.i);
    });

  for (const item of unpinned) {
    const w = Math.min(item.w, cols);
    const slot = findFirstSlotLTRB(placed, w, cols);
    if (slot) {
      placeAt(item, slot.x, slot.y);
      continue;
    }
    const bottom = placed.reduce(
      (m, i) => Math.max(m, i.y + layoutItemH(i)),
      0
    );
    placeAt(item, 0, bottom);
  }

  return placed;
};

/** 빈 y row 제거 (위→아래) */
const collapseEmptyRows = (items: Layout[]): void => {
  let changed = true;
  while (changed) {
    changed = false;
    const ys = [...new Set(items.map((i) => i.y))].sort((a, b) => a - b);
    if (ys.length === 0) return;

    for (let y = 0; y <= ys[ys.length - 1]; y++) {
      if (!items.some((i) => i.y === y)) {
        items.forEach((item, idx) => {
          if (item.y > y) {
            items[idx] = { ...item, y: item.y - 1 };
            changed = true;
          }
        });
        break;
      }
    }
  }
};

export const addLayouttoLast = (
  layout: Layout[],
  item: CardInfo,
  cardInfos: CardInfo[]
) => {
  const isVisible = layout.some((d) => d.i === item.i);
  const sortOrderRef = layout.map((d) => ({ ...d }));

  if (isVisible) {
    return compactChartLayout(
      layout.filter((d) => d.i !== item.i).map((d) => ({ ...d, h: 1 })),
      LAYOUT_COLS,
      undefined,
      sortOrderRef
    );
  }

  const newCard = cardInfos.find((d) => d.i === item.i);
  if (!newCard) return layout;

  // "맨 뒤부터 추가"를 위해 현재 레이아웃의 가장 아래 끝(y + h) 다음 줄에 넣는다.
  const bottomY = layout.reduce(
    (max, curr) => Math.max(max, curr.y + (curr.h ?? 1)),
    0
  );
  return compactChartLayout(
    [
      ...layout.map((d) => ({ ...d, h: 1 })),
      {
        i: item.i,
        x: 0,
        y: bottomY,
        w: newCard.graphType === "donut" ? 1 : 2,
        h: 1,
      },
    ],
    LAYOUT_COLS,
    undefined,
    sortOrderRef
  );
};

/** horizontal(L→R, 위→아래) → vertical. add/remove/resize/move 공통 */
export const compactChartLayout = (
  layout: Layout[],
  cols: number,
  pin?: PinnedLayoutItem,
  sortOrderRef?: Layout[]
): Layout[] => {
  if (!layout.length || cols <= 0) return layout;

  const items = reflowItemsLTRB(
    layout.map((item) => ({
      ...item,
      w: Math.min(item.w, cols),
      h: layoutItemH(item),
    })),
    cols,
    pin,
    sortOrderRef
  );

  collapseEmptyRows(items);

  return sortLayoutsByPosition(items);
};

const isCountLayoutItem = (id: string) => id.includes("Count");

const splitCountAndChartLayouts = (layouts: Layout[]) => ({
  countLayouts: layouts.filter((item) => isCountLayoutItem(item.i)),
  chartLayouts: layouts.filter((item) => !isCountLayoutItem(item.i)),
});

/** 드롭: 빈 칸이면 그 자리 배치, 겹치면 드래그 카드 배치 후 겹친 카드는 오른쪽→아래로 밀림 */
const snapDrop = (
  layout: Layout[],
  cols: number,
  draggedId: string,
  dropX?: number,
  dropY?: number,
  _rowChanged = false,
  _oldX?: number,
  _oldY?: number
): Layout[] => {
  const items = layout.map((item) => ({ ...item }));
  const idx = items.findIndex((i) => i.i === draggedId);
  if (idx === -1) return layout;

  const dragged = items[idx];
  const w = Math.min(dragged.w, cols);
  const y = dropY ?? dragged.y;
  let x = Math.max(0, Math.min(dropX ?? dragged.x, cols - w));

  if (w === 1) {
    const wideAtDrop = items.find(
      (item) =>
        item.i !== draggedId &&
        item.y === y &&
        item.w > 1 &&
        overlapsColumn(item, x)
    );
    if (wideAtDrop) x = wideAtDrop.x;
  }

  const exclude = new Set([draggedId]);

  if (canPlaceAt(items, exclude, x, y, w, cols)) {
    items[idx] = { ...dragged, x, y, w };
    return items;
  }

  const overlapping = items
    .filter(
      (item) =>
        item.i !== draggedId &&
        item.y === y &&
        item.x < x + w &&
        item.x + item.w > x
    )
    .sort((a, b) => a.x - b.x || a.i.localeCompare(b.i));

  items[idx] = { ...dragged, x, y, w };

  for (const item of overlapping) {
    displaceItemRightThenDown(items, item.i, cols, x + w);
  }

  return items;
};

/** 밀린 카드: 같은 row 오른쪽(드래그 카드 오른쪽부터) → 아래 row L→R·T→B */
const displaceItemRightThenDown = (
  items: Layout[],
  itemId: string,
  cols: number,
  minX = 0
): void => {
  const idx = items.findIndex((i) => i.i === itemId);
  if (idx === -1) return;

  const item = items[idx];
  const w = Math.min(item.w, cols);
  const exclude = new Set([itemId]);
  const rowY = item.y;
  const startX = Math.max(item.x + 1, minX);

  for (let tryX = startX; tryX <= cols - w; tryX++) {
    if (canPlaceAt(items, exclude, tryX, rowY, w, cols)) {
      items[idx] = { ...item, x: tryX, y: rowY, w };
      return;
    }
  }

  const maxY =
    items.reduce((m, i) => Math.max(m, i.y + layoutItemH(i)), 0) +
    items.length +
    1;

  for (let tryY = rowY + 1; tryY <= maxY; tryY++) {
    for (let tryX = 0; tryX <= cols - w; tryX++) {
      if (canPlaceAt(items, exclude, tryX, tryY, w, cols)) {
        items[idx] = { ...item, x: tryX, y: tryY, w };
        return;
      }
    }
  }

  const bottom = items.reduce(
    (m, i) => (i.i === itemId ? m : Math.max(m, i.y + layoutItemH(i))),
    0
  );
  items[idx] = { ...item, x: 0, y: bottom, w };
};

const placeDisplacedItems = (layout: Layout[], cols: number): Layout[] => {
  const items = layout.map((i) => ({ ...i }));
  const displaced = items
    .filter((i) => i.x >= cols)
    .sort((a, b) => a.y - b.y || a.x - b.x);

  for (const item of displaced) {
    displaceItemRightThenDown(items, item.i, cols);
  }

  return items;
};

const finalizeChartLayout = (
  layout: Layout[],
  cols: number,
  preSnap: Layout[]
): Layout[] => {
  if (layout.some((i) => i.x >= cols)) return placeDisplacedItems(layout, cols);

  const snapMoved = layout.some((item) => {
    const prev = preSnap.find((p) => p.i === item.i);
    return prev != null && (prev.x !== item.x || prev.y !== item.y);
  });
  if (snapMoved) return layout;

  return compactChartLayout(layout, cols);
};

type ChartLayoutDragMeta = {
  draggedId: string;
  dropX?: number;
  dropY?: number;
  rowChanged?: boolean;
  oldX?: number;
  oldY?: number;
};

type ChartLayoutGridOptions = {
  cols?: number;
  /** true: layout만 소스로 사용 (API 조회 등). cardLayouts 병합 없음 */
  replace?: boolean;
} & Partial<ChartLayoutDragMeta>;

/** 드래그: 빈 칸이면 그대로 배치, 겹치면 밀린 카드는 오른쪽→아래 */
const processChartLayout = (
  layout: Layout[],
  cols: number,
  dragMeta?: ChartLayoutDragMeta
): Layout[] => {
  if (!layout.length) return layout;

  if (dragMeta?.draggedId) {
    const snapped = snapDrop(
      [...layout],
      cols,
      dragMeta.draggedId,
      dragMeta.dropX,
      dragMeta.dropY,
      dragMeta.rowChanged,
      dragMeta.oldX,
      dragMeta.oldY
    );

    const dropX = dragMeta.dropX ?? 0;
    const dropY = dragMeta.dropY ?? 0;

    return compactChartLayout(
      snapped,
      cols,
      {
        id: dragMeta.draggedId,
        x: dropX,
        y: dropY,
      },
      layout
    );
  }

  const preSnap = layout.map((item) => ({ ...item }));
  return finalizeChartLayout([...layout], cols, preSnap);
};

export const replaceChartInLayout = (
  layouts: Layout[],
  currentId: string,
  newId: string,
  cols = LAYOUT_COLS
): Layout[] => {
  if (currentId === newId) return layouts;
  const { countLayouts, chartLayouts } = splitCountAndChartLayouts(layouts);
  const updated = syncRowHeights(
    chartLayouts
      .filter((item) => item.i !== newId)
      .map((item) =>
        item.i === currentId
          ? ({
              ...item,
              i: newId,
              graphType: undefined,
            } as Layout)
          : item
      )
  );
  return sortLayoutsByPosition([...countLayouts, ...updated]);
};

export const removeChartFromLayout = (
  layouts: Layout[],
  chartId: string,
  cols = LAYOUT_COLS
): Layout[] => {
  const sortOrderRef = layouts.map((item) => ({ ...item }));
  const filtered = layouts.filter((item) => item.i !== chartId);
  const { countLayouts, chartLayouts } = splitCountAndChartLayouts(filtered);
  const normalized = normalizeChartLayoutItems(
    chartLayouts.map((item) => ({ ...item })),
    cols
  );
  const compacted = compactChartLayout(
    normalized,
    cols,
    undefined,
    sortOrderRef
  );
  return sortLayoutsByPosition([...countLayouts, ...compacted]);
};

/** AddChart Apply: 선택된 차트 목록으로 교체 + L→R·T→B compact (Summary Count 레이아웃 유지) */
export const applyChartLayoutFromSelection = (
  layouts: Layout[],
  selectedCharts: Layout[],
  cols = LAYOUT_COLS
): Layout[] => {
  const sortOrderRef = layouts.map((item) => ({ ...item }));
  const { countLayouts } = splitCountAndChartLayouts(layouts);
  const normalized = normalizeChartLayoutItems(
    selectedCharts.map((item) => ({ ...item })),
    cols
  );
  const compacted = compactChartLayout(
    normalized,
    cols,
    undefined,
    sortOrderRef
  );
  return sortLayoutsByPosition([...countLayouts, ...compacted]);
};

/** w/h가 없을 때만 기본 크기 적용 — 사용자가 변경한 크기는 유지 */
export const normalizeChartLayoutItems = (
  layout: Layout[],
  cols = LAYOUT_COLS
): Layout[] =>
  layout.map((item) => ({
    ...item,
    w: layoutItemW(item, cols),
    h: layoutItemH(item),
  }));

const buildDefaultChartLayout = (ids: string[], cols: number): Layout[] => {
  const layout: Layout[] = [];
  let x = 0;
  let y = 0;
  let rowH = 0;

  for (const id of ids) {
    const w = chartNaturalW(id);
    const h = 1;
    if (x + w > cols) {
      x = 0;
      y += rowH;
      rowH = 0;
    }
    layout.push({ i: id, x, y, w, h });
    x += w;
    rowH = Math.max(rowH, h);
  }
  return syncRowHeights(layout);
};

const DEFAULT_CHART_LAYOUT_ORDER = [
  "organization",
  "subscriptionStatus",
  "spectrumRecorders",
  "covaRecorders",
  "vmaxIPRecorders",
  "vmaxA1Recorders",
  "Recorders",
  "cameras",
  "subscriptionKeys",
  "Users",
  "clientDevices",
  "userLogin",
  "bestPageView",
  "activeAlert",
  "cloudStorage",
  "videoShare",
];

export function formatPercent(value: number, total: number) {
  const p = total > 0 ? (value / total) * 100 : 0;
  return `${p.toFixed(1)}%`;
}

// 레이아웃 찾기 헬퍼 함수
const findLayout = (layouts: Layout[], id: string): Layout | undefined => {
  return layouts.find((layout) => layout.i === id);
};

// 레이아웃 기본값 적용 헬퍼 함수
const applyLayoutDefaults = (
  item: CardInfo,
  layout: Layout | undefined
): CardData => {
  return {
    ...item,
    key: item.i,
    x: layout?.x ?? 0,
    y: layout?.y ?? 0,
    w: layout?.w ?? chartNaturalW(item.i),
    h: layout?.h ?? 1,
  } as CardData;
};

export const createCardData = (
  graphType: "card" | "not-card",
  cardInfos: CardInfo[],
  cardLayouts: StatsLayout[]
): CardData[] => {
  // cardLayouts의 순서를 따라 생성 (모바일에서 배열 순서대로 표시되도록)
  if (graphType === "card") {
    return cardInfos
      .filter((item) => item.graphType === "card")
      .map((item) =>
        applyLayoutDefaults(item, findLayout(cardLayouts, item.i))
      );
  }

  const filteredInfos = cardInfos.filter((item) => item.graphType !== "card");

  // cardLayouts의 순서대로 정렬된 cardInfos 생성 (매칭 실패·중복 i 제거)
  const sortedInfos = cardLayouts
    .map((layout) => {
      const info = filteredInfos.find((info) => info.i === layout.i);
      if (!info) return undefined;
      return {
        ...info,
        graphType: layout.graphType ? layout.graphType : info.graphType,
      } as CardInfo;
    })
    .filter((info): info is CardInfo => info !== undefined);

  const seenIds = new Set<string>();
  const uniqueSorted = sortedInfos.filter((info) => {
    if (seenIds.has(info.i)) return false;
    seenIds.add(info.i);
    return true;
  });

  return uniqueSorted.map((item) =>
    applyLayoutDefaults(item, findLayout(cardLayouts, item.i))
  );
};

export const sortCardData = (data: (Layout & { key?: string })[]): Layout[] => {
  return sortLayoutsByPosition(data).map((item) => ({
    ...item,
    i: item.i ?? "",
  }));
};

export const createLayouts = (
  data: Layout[],
  mdTransform: "index" | "position",
  lgMaxX: number,
  mdMaxX: number,
  mdMaxY: number
) => {
  const normalized = normalizeChartLayoutItems(data, lgMaxX);

  const lgLayouts = normalized.map((item) => ({
    ...item,
    w: layoutItemW(item, lgMaxX),
  }));

  const mdLayouts: Layout[] = (() => {
    if (mdTransform === "index") {
      return compactChartLayout(normalized, mdMaxX);
    }
    return syncRowHeights(
      normalized.map((item) => ({
        i: item.i,
        x: item.x % mdMaxX,
        y: Math.floor(item.y / mdMaxY),
        w: Math.min(item.w, mdMaxX),
        h: item.h,
      }))
    );
  })();

  let smY = 0;
  const smLayouts: Layout[] = normalized.map((item) => {
    const h = layoutItemH(item);
    const layout = {
      i: item.i,
      x: 0,
      y: smY,
      w: 1,
      h,
    };
    smY += h;
    return layout;
  });

  return {
    lg: lgLayouts,
    md: mdLayouts,
    sm: smLayouts,
  };
};
export const getCategory = (pathname: string) =>
  //level에 상관없이 모든 메뉴가 보여야하므로 모든 메뉴를 조회
  dwMenuData.find((menu) => pathname.includes(menu?.includeRouteName || ""));
export const getMenuName = (pathname: string, children: RoutesProp[]) => {
  let menuName =
    children.find((child) => child.routeName === pathname)?.name ?? "";
  if (menuName) return menuName;
  if (logoutAbleUrl.some((url) => pathname.includes(url))) {
    switch (pathname) {
      case "/reset":
        return "";
      case "/guest/video/player":
        return "Guest Video Share";
      case "/signup":
        return "";
      case "/login/free-trial":
        return "";
      case "/terms/eula":
        return "";
      case "/terms/sla":
        return "";
      case "/terms/cookie-policy":
        return "";
      default:
        return "";
    }
  }
  if (pathname.includes("login")) {
    return "";
  }
  return "";
};

export const getRowsAndItems = (
  rows: RowsData[] = [],
  items: CategoryDef[] = []
) => {
  const sortedRows = rows.sort((a, b) => b.value - a.value);
  const data: CategoryDef[] = sortedRows.map((item, index) => ({
    key: item.label,
    label: item.label,
    color: items?.[index]?.color ?? "",
  }));
  return {
    rows: sortedRows ?? [],
    items: data ?? [],
  };
};

export const getLegendForKey = (
  data: { [key: string]: number },
  items: CategoryDef[]
) => {
  return items.map((item) => ({
    label: item.label,
    value: data[item.key] ?? 0,
    color: item.color,
  }));
};

const getRecorderTypeOrder = (label: string): number => {
  const lower = (label ?? "").toLowerCase();
  if (lower === "spectrum") return 0;
  if (lower === "cova") return 1;
  if (lower.includes("ip")) return 2;
  if (lower.includes("a1")) return 3;
  return 99;
};

const getOrganizationTypeOrder = (label: string): number => {
  const lower = (label ?? "").toLowerCase();
  if (lower === "cp") return 0;
  if (lower === "sub cp") return 1;
  if (lower === "eu") return 2;
  return 99;
};

export const sortToRecorderType = <T extends Record<string, unknown>>(
  rows: T[],
  key = "label"
) => {
  return rows.sort(
    (a, b) =>
      getRecorderTypeOrder(String(a[key] ?? "")) -
      getRecorderTypeOrder(String(b[key] ?? ""))
  );
};

export const getUniqueLabelRowsData = (
  data: { [key: string]: string | number; count: number }[] = [],
  key: string,
  type?: "userCount" | "organizationCount" | "recorderCount" | "cameraCount"
) => {
  const seen = new Set<string>();
  const rows: RowsData[] = [];

  data.forEach((item) => {
    const label = item[key] as string;
    if (!seen.has(label)) {
      seen.add(label);
      rows.push({
        label: label.toLowerCase() === "sub" ? "Sub CP" : label,
        value: item.count,
      });
    }
  });
  if (type === "userCount" || type === "organizationCount") {
    return rows.sort(
      (a, b) =>
        getOrganizationTypeOrder(a.label) - getOrganizationTypeOrder(b.label)
    );
  }
  if (type === "recorderCount") {
    return sortToRecorderType(rows);
  }
  return rows;
};

const SUMMARY_COUNT_LAYOUTS: Layout[] = [
  { i: "userCount", x: 0, y: 0, w: 1, h: 1 },
  { i: "organizationCount", x: 1, y: 0, w: 1, h: 1 },
  { i: "recorderCount", x: 2, y: 0, w: 1, h: 1 },
  { i: "cameraCount", x: 3, y: 0, w: 1, h: 1 },
];

export const INITIAL_CARD_LAYOUTS: Layout[] = [
  ...SUMMARY_COUNT_LAYOUTS,
  ...buildDefaultChartLayout(DEFAULT_CHART_LAYOUT_ORDER, LAYOUT_COLS),
];

export const applyChartLayoutFromGrid = (
  layout: Layout[],
  cardLayouts: Layout[],
  options?: ChartLayoutGridOptions
) => {
  const cols = options?.cols ?? LAYOUT_COLS;
  const snapshot = layout.map((item) => ({ ...item }));
  const { countLayouts, chartLayouts } = splitCountAndChartLayouts(
    options?.replace ? snapshot : cardLayouts
  );

  if (!chartLayouts.length) {
    return sortLayoutsByPosition(countLayouts);
  }
  if (options?.draggedId) {
    let charts = normalizeChartLayoutItems(
      chartLayouts.map((item) => ({ ...item })),
      cols
    );
    charts = processChartLayout(charts, cols, options as ChartLayoutDragMeta);
    return sortLayoutsByPosition([...countLayouts, ...charts]);
  }

  const chartLayout = layout.filter((item) => !isCountLayoutItem(item.i));
  const updatedMap = new Map(chartLayouts.map((item) => [item.i, item]));
  chartLayout.forEach((item) => {
    updatedMap.set(item.i, item);
  });

  let charts = options?.replace ? chartLayout : Array.from(updatedMap.values());
  charts = normalizeChartLayoutItems(charts, cols);
  charts = options?.replace
    ? compactChartLayout(charts, cols, undefined, snapshot)
    : compactChartLayout(charts, cols);

  return sortLayoutsByPosition([...countLayouts, ...charts]);
};

export const CHART_MARGIN_TOP = 10;
export const CHART_MARGIN_BOTTOM = 30;
export const CHART_CONTENT_HEIGHT = 200;
export const CHART_PLOT_HEIGHT =
  CHART_CONTENT_HEIGHT - CHART_MARGIN_TOP - CHART_MARGIN_BOTTOM;

export const getLimitLineAxisY = (
  cost: number,
  data: Record<string, unknown>[],
  key: string,
  marginTop: number = CHART_MARGIN_TOP,
  marginBottom: number = CHART_MARGIN_BOTTOM
) => {
  if (!data.length || cost <= 0) return null;
  const dataMax = Math.max(0, ...data.map((d) => Number(d[key]) || 0));
  const yMax = Math.max(0, dataMax);
  const displayedMax = Math.max(yMax, cost);
  const plotHeight = CHART_PLOT_HEIGHT;
  return marginTop + (1 - cost / displayedMax) * plotHeight;
};

export const isSameCardDataItem = (a: CardData, b: CardData) =>
  a.key === b.key &&
  a.graphType === b.graphType &&
  a.x === b.x &&
  a.y === b.y &&
  a.w === b.w &&
  a.h === b.h &&
  a.title === b.title &&
  a.groupMode === b.groupMode &&
  a.lengedType === b.lengedType;
export const cols = {
  lg: 4,
  md: 2,
  sm: 1,
};
